import React from "react";

function DrugDetails ({ drug, onAddToCart }) {
  if (!drug) return <p>Loading drug details...</p>;

  return (
    <div className="max-w-3xl mx-auto p-6 shadow rounded bg-white">
      {/* Header */}
      <h1 className="text-2xl font-bold mb-2">{drug.name}</h1>
      <p className="text-gray-500 mb-4">{drug.category}</p>

      {/* Description */}
      <section className="mb-4">
        <h2 className="font-semibold text-lg">Description</h2>
        <p>{drug.description}</p>
      </section>

      {/* Dosage */}
      <section className="mb-4">
        <h2 className="font-semibold text-lg">Dosage</h2>
        <p>{drug.dosage}</p>
      </section>

      {/* Side Effects */}
      <section className="mb-4">
        <h2 className="font-semibold text-lg">Side Effects</h2>
        <ul className="list-disc ml-5">
          {drug.sideEffects?.map((effect, index) => (
            <li key={index}>{effect}</li>
          ))}
        </ul>
      </section>

      {/* Warnings */}
      <section className="mb-4">
        <h2 className="font-semibold text-lg text-red-600">Warnings</h2>
        <p>{drug.warnings}</p>
      </section>

      {/* Price + Action */}
      <div className="flex justify-between items-center mt-6">
        <span className="text-xl font-bold">${drug.price}</span>
        <button
          onClick={() => onAddToCart(drug)}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Add to Order
        </button>
      </div>
    </div>
  );
};

export default DrugDetails;